import React, { useState } from "react";
import "./Header.css";
import { Link } from "react-scroll";

import Logo from "../../assets/logo.png";
import Bars from "../../assets/bars.png";

const Header = () => {
  const mobile = window.innerWidth <= 912 ? true : false;
  const [menuOpened, setMenuOpened] = useState(false);
  return (
    <div className="header">
      <img src={Logo} alt="" className="logo" />
      {menuOpened === false && mobile === true ? (
        <div
          className="menu-bar"
          style={{
            backgroundColor: "var(--appColor",
            padding: "0.5rem",
            borderRadius: "5px",
            position: "fixed",
          }}
          onClick={() => setMenuOpened(true)}
        >
          <img
            src={Bars}
            alt=""
            style={{ width: "1.5rem", height: "1.5rem" }}
          />
        </div>
      ) : (
        <>
          <ul className="header-menu">
            <span>
              <svg
                onClick={() => {
                  setMenuOpened(false);
                }}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </span>
            <Link
              activeClass="active"
              to="home"
              spy={true}
              smooth={true}
              offset={-40}
              duration={500}
            >
              <li
                onClick={() => {
                  setMenuOpened(false);
                }}
              >
                Home
              </li>
            </Link>
            <Link
              activeClass="active"
              to="programs"
              spy={true}
              smooth={true}
              offset={-40}
              duration={500}
            >
              <li
                onClick={() => {
                  setMenuOpened(false);
                }}
              >
                Programs
              </li>
            </Link>
            <Link
              activeClass="active"
              to="reasons"
              spy={true}
              smooth={true}
              offset={-40}
              duration={500}
            >
              <li
                onClick={() => {
                  setMenuOpened(false);
                }}
              >
                Why us
              </li>
            </Link>
            <Link
              activeClass="active"
              to="plans"
              spy={true}
              smooth={true}
              offset={-40}
              duration={500}
            >
              <li
                onClick={() => {
                  setMenuOpened(false);
                }}
              >
                Plans
              </li>
            </Link>
            <Link
              activeClass="active"
              to="testimonials"
              spy={true}
              smooth={true}
              offset={-40}
              duration={500}
            >
              <li
                onClick={() => {
                  setMenuOpened(false);
                }}
              >
                Testimonials
              </li>
            </Link>
          </ul>
        </>
      )}
    </div>
  );
};

export default Header;
